export default {
    pageName: 'ทำงานนอกสถานที่วันนี้',
    people: 'คน',
    search: {
        title: '',
        placeholder: 'ค้นหารหัสพนักงาน'
    },
    header: {
        detail: 'รายละเอียด',
        status: 'สถานะ'
    }
}
